module.exports = __webpack_public_path__ + "508e4976db43b05d743f35eafd60c49b.pdf";